import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { appService } from '../../../../app/_services/app.service';
import { CommonService } from '../../../../app/_services/common.service';
import { EwayBillService } from '../../services/EwayBill/eway-bill.service';
import { MobileDetectionService } from '../../services/mobile-detection.service';
import { OrdersService } from '../../services/orders/orders.service';
import { CookieService } from 'ngx-cookie-service';
import { DecryptPipe } from '../../../../app/auth/_services/encrypt-decrypt.pipe';
import { TranslateService } from '@ngx-translate/core';
import { Helpers } from '../../../../app/helpers';

@Component({
  selector: 'app-eway-bill-setting',
  templateUrl: './eway-bill-setting.component.html',
  styleUrls: ['./eway-bill-setting.component.scss']
})
// Added by priya - 27/05/2026 - cn(PRIYA-MAY26-010)
export class EwayBillSettingComponent implements OnInit {

  static that: EwayBillSettingComponent;
  @Output() onCloseEvent = new EventEmitter<any>();
  CompanyId: any;
  CompanyGSTIN: any;
  userId: any;
  TenantId: any;
  isEwayFormSubmit: boolean = false;
  EwayValidityData: any = {};
  EwayHours = {
    lable: 'Hours',
    formControlName: 'EwayHours',
    dataField: 'EwayHours',
    isRequired: true,
    type: 'number',
    placeholder: 'Enter Hours',
  };
  Status: any = {
    lable: 'Status',
    formControlName: 'Status',
    dataField: 'Status',
    isRequired: true,
    placeholder: 'Select Status',
    isSearchByApi: false,
    typeOfField: 'dropdown',
    isValueBind: true,
    isMultipleSelect: true
  };
  EwayReason: any = {
    lable: 'Extend Validity Reason',
    formControlName: 'EwayReason',
    dataField: 'EwayReason',
    isRequired: true,
    placeholder: 'Select Reason',
    isSearchByApi: false,
    typeOfField: 'dropdown',
    isValueBind: true
  };
  EwayRemark = {
    lable: 'Extend Remark',
    formControlName: 'EwayRemark',
    dataField: 'EwayRemark',
    isRequired: true,
    type: 'textarea',
    placeholder: 'Enter Extend Remark',
  };
  IsActive: any = {
    lable: "IsActive",
    dataField: 'IsActive',
    formControlName: 'IsActive',
    isRequired: false,
    type: 'toggle'
  };

  constructor(
    private orderService: OrdersService,
    private _appService: appService,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private commonService: CommonService,
    private Eway: EwayBillService,
    private mobileDetectionService: MobileDetectionService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
    private translate: TranslateService,
  ) {
    EwayBillSettingComponent.that = this;
  }

  ngOnInit() {
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.CompanyGSTIN = JSON.parse(localStorage.getItem('ChnageCompnayId')).SelectedCompantGSTIN;
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    this.TenantId = JSON.parse(localStorage.getItem("ChnageCompnayId")).TenantId;
    this.GetValidityReason();
    this.GetTrackingStatus();
    this.GetEwayBillSetting();
  }

  getEwayChangedValue(value, data) {
    const newValue = value && typeof value === 'object' && 'value' in value ? value.value : value;
    if (data.dataField == 'EwayReason') {
      let selectedItem = data.dropdownList.find(item => item.value === value);
      this.EwayValidityData[data.dataField] = newValue;
      this.EwayValidityData.EwayReasonName = selectedItem.name;
    } else if (data.dataField == 'Status') {
      let selectedItem = data.dropdownList.find(item => item.value === value);
      this.EwayValidityData[data.dataField] = newValue;
      this.EwayValidityData.StatusName = selectedItem.name;
    } else if (data.dataField == 'IsActive') {
      this.EwayValidityData.IsActive = value;
    } else if (newValue) {
      this.EwayValidityData[data.dataField] = newValue;
    }
  }

  GetValidityReason() {
    this.Eway.GetValidityReason().then(data => {
      if (data.length > 0) {
        this.EwayReason.dropdownList = data || [];
      }
    })
  }

  GetTrackingStatus() {
    this.orderService.GetTrackingStatus(null).then(data => {
      if (data.length > 0) {
        this.Status.dropdownList = data || [];
      }
    })
  }

  GetEwayBillSetting(){
    this._appService.GetById("EwayBill", "GetEwayBillSetting", this.CompanyId).subscribe(
    (response) => {
      if(response && response.length){
        // this.EwayValidityData = response[0];
        this.EwayValidityData = {};
        this.EwayValidityData.Id = response[0].Id;
        this.EwayValidityData.EwayHours = response[0].Hours;
        this.EwayValidityData.IsActive = response[0].IsActive;
        this.EwayValidityData.EwayRemark = response[0].ExtendRemark;
        // this.EwayValidityData.Status = response[0].Status;
        this.EwayValidityData.Status = response[0].Status.split(',').map(x => x.trim().toLowerCase());
        this.EwayValidityData.StatusName = response[0].StatusName;
        this.EwayValidityData.EwayReason = response[0].EwayReason;
        this.EwayValidityData.EwayReasonName = response[0].EwayReasonName;
        // var obj: any = {};
        // obj.value = response[0].Status;
        // obj.name = response[0].StatusName;
        // this.Status.dropdownList = [];
        // this.Status.dropdownList.push(obj);
        // var objReason: any = {};
        // objReason.value = response[0].EwayReason;
        // objReason.name = response[0].EwayReasonName;
        // this.EwayReason.dropdownList = [];
        // this.EwayReason.dropdownList.push(objReason);
      }
    },
    (err) => {
      this.toastr.error(err._body.replace(/"/g, ""), "error");
    });
  }

  SaveEwayBillSetting() {
    this.isEwayFormSubmit = true;
    if (this.ValidateEwayFieldData()) {
      if (this.EwayValidityData.EwayHours > 8) {
        this.toastr.warning("Hours cannot be more than 8 hours");
        return;
      }
      Helpers.setLoading(true);
      var obj: any = {};
      obj.Id = this.EwayValidityData.Id;
      obj.Hours = this.EwayValidityData.EwayHours;
      obj.Status = Array.isArray(this.EwayValidityData.Status) ? this.EwayValidityData.Status.join(',') : null;
      obj.ExtendReason = this.EwayValidityData.EwayReason;
      obj.ExtendRemark = this.EwayValidityData.EwayRemark;
      obj.IsActive = this.EwayValidityData.IsActive || false;
      obj.CompanyId = this.CompanyId;
      obj.UserId = this.userId;
      this._appService.Post("EwayBill", "SaveEwayBillSetting", obj).subscribe(
        (response) => {
            this.toastr.success('Settings saved successfully!');
            this.closeEwayModal();
            this.EwayValidityData = {};
          Helpers.setLoading(false);
        },
        (err) => {
          Helpers.setLoading(false);
          this.toastr.error("Error occurred while saving setting!", "error");
        });
    }
  }

  ValidateEwayFieldData() {
    var IsAllDataDone: any = true;
    if (!this.EwayValidityData.EwayHours || this.EwayValidityData.EwayHours === null || this.EwayValidityData.EwayHours === undefined) {
      IsAllDataDone = false;
    }
    if (!this.EwayValidityData.EwayReason) {
      IsAllDataDone = false;
    }
    if (!this.EwayValidityData.Status) {
      IsAllDataDone = false;
    }
    if (!this.EwayValidityData.EwayRemark) {
      IsAllDataDone = false;
    }
    if (!IsAllDataDone) {
      var RequiredError = this.translate.instant("DriverDetailsById.RequiredError");
      this.toastr.error(RequiredError, "error");
    }
    return IsAllDataDone;
  }

  closeEwayModal() {
    this.onCloseEvent.emit();
  }

}
